"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT = void 0;
exports.EVENT = {
    START: 'start',
    PREV_TURN: 'prev-turn',
    NEXT_TURN: 'next-turn',
    COMPLETE: 'complete',
    END: 'end'
};
//# sourceMappingURL=constants.js.map